import { render } from "./HomeDecore.vue?vue&type=template&id=68b5470f"
import script from "./HomeDecore.vue?vue&type=script&lang=js"
export * from "./HomeDecore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__